import React from "react";
import logger from "logger";
import { TaskActions, getWrappedJSON } from "Utils/Common";
import store from "store";
import Constants from "Utils/Constants";
import axios from "axios";
import { showDialog } from "DialogProvider";
import NotificationPopup from "TaskDialogCommon/NotificationPopup";
import toastMaker from "Common/toastmaker";

export const getRssNameFromCode = function(code) {
  if (code === undefined) {
    return "Undefined";
  }
  if (code === "r1") {
    return "Food";
  }
  if (code === "r2") {
    return "Wood";
  }
  if (code === "r3") {
    return "Ore";
  }
  if (code === "r4") {
    return "Stone";
  }
  if (code === "gold") {
    return "Gold";
  }
  if (code === "r7") {
    return "Pearls";
  }
  return "Rss " + code;
};

export function downloadfile(filename) {
  var url = Constants.downloadApiPath + "?filename=" + encodeURI(filename);
  var link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.click();
}

export function showAllNotifications(errorlogs) {
  if (errorlogs === undefined || errorlogs === null) {
    alert("No notifications to show.");
    return;
  }
  showDialog(<NotificationPopup errorlogs={errorlogs} open={true} />);
}

export const doTask = (taskname, taskConfig) => {
  logger.log("doTask called", taskname, taskConfig);
  startTask(taskname, taskConfig);
};

function startTask(taskname, taskparams) {
  logger.log("START_ACTION:" + TaskActions.START_ACTION);
  store.dispatch({ type: "ISLOADING", payload: true });
  const sendJSON = {
    action: TaskActions.START_ACTION,
    taskname: taskname,
    taskparams: taskparams,
  };
  doTaskAction(sendJSON);
  const accountdetail = store.getState().rootScope.accountdetail;
  accountdetail.lastconfig[taskname] = taskparams;
}

export function doTaskAction(actiondata) {
  var callbackfunc = ({ data: { ok, data, message } }) => {
    logger.log("callbackfunc", ok, data);
    if (ok) {
      const taskId = data.taskid;
      const UserData = store.getState().rootScope;
      logger.log("rootscope start", UserData);
      const accountdetailold = UserData.accountdetail;
      if (!taskId) {
        const accountdetail = {};
        const servicename = data.servicename;
        if (servicename === "autobubble") {
          if (data.autobubble !== undefined) {
            accountdetail.autobubble = data.autobubble;
          }
        } else if (servicename === "autocalendar") {
          if (data.autocalendar !== undefined) {
            accountdetail.autocalendar = data.autocalendar;
          }
        } else if (servicename === "autoclaimprizes") {
          if (data.autoclaimprizes !== undefined) {
            accountdetail.autoclaimprizes = data.autoclaimprizes;
          }
        } else if (servicename === "autodonate") {
          if (data.autodonate !== undefined) {
            accountdetail.autodonate = data.autodonate;
          }
        } else if (servicename === "wallremover") {
          if (data.config) {
            if (accountdetail.wallremoverconfig) {
              accountdetail.wallremoverconfig = {
                ...accountdetailold.wallremoverconfig,
                ...data.config,
              };
            } else {
              accountdetail.wallremoverconfig = data.config;
            }
          } else {
            accountdetail.wallremoverconfig = null;
          }
        }
        store.dispatch({ type: "UPDATEACCOUNTDETAIL", payload: accountdetail });
        store.dispatch({ type: "ISLOADING", payload: false });
        return;
      }
      const accountdetail = {
        tasks: [...accountdetailold.tasks],
        taskhistory: [
          ...(accountdetailold.taskhistory ? accountdetailold.taskhistory : []),
        ],
      };
      let objectToUpdate = null;
      for (var index = 0; index < accountdetail.tasks.length; ++index) {
        if (accountdetail.tasks[index].taskid === taskId) {
          objectToUpdate = accountdetail.tasks[index];
          break;
        }
      }
      if (!objectToUpdate) {
        accountdetail.tasks.push(data);
      } else {
        Object.assign(objectToUpdate, data);
      }

      objectToUpdate = null;

      // update task in taskhistor
      if (accountdetail.taskhistory) {
        for (index = 0; index < accountdetail.taskhistory.length; ++index) {
          if (accountdetail.taskhistory[index].taskid === taskId) {
            objectToUpdate = accountdetail.taskhistory[index];
            break;
          }
        }
        if (objectToUpdate) {
          Object.assign(objectToUpdate, data);
        }
      }
      store.dispatch({ type: "UPDATEACCOUNTDETAIL", payload: accountdetail });

      objectToUpdate = null;
      logger.log("rootscope end", UserData);

      const runningtasks = UserData.runningtasks || [];

      for (index = 0; index < runningtasks.length; ++index) {
        if (runningtasks[index].taskid === taskId) {
          objectToUpdate = UserData.runningtasks[index];
          break;
        }
      }
      if (objectToUpdate) {
        Object.assign(objectToUpdate, data);
      }
      store.dispatch({ type: "SETRUNNINGTASKS", payload: [...runningtasks] });
    } else {
      /*
      toastMaker.makeToast(message, {
        variant: "error",
      });
      */
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  };
  const errorfunc = (error) => {
    if (error.response) {
      toastMaker.makeToast(error.response.data.message, {
        variant: "error",
      });
    } else {
      console.error(error, error.response);
    }
    store.dispatch({ type: "ISLOADING", payload: false });
    throw error;
  };
  return doTaskActionWithCallback(actiondata, callbackfunc, errorfunc);
}

export function doTaskActionWithCallback(actiondata, callbackfunc, errorfunc) {
  logger.log("TaskService.doTaskAction called: ", actiondata);
  store.dispatch({ type: "ISLOADING", payload: true });
  return axios
    .post(Constants.dotaskactionApiPath, getWrappedJSON(actiondata), {
      timeout: 5 * 60 * 1000,
    })
    .then(callbackfunc)
    .catch(errorfunc);
}

export function updateTaskStatus(taskId, callback) {
  store.dispatch({ type: "ISLOADING", payload: true });
  var sendJSON = {
    action: TaskActions.UPDATE_STATUS_ACTION,
    taskId: taskId,
  };
  if (!callback) {
    return doTaskAction(sendJSON);
  } else {
    return doTaskActionWithCallback(sendJSON, callback);
  }
}

export function stopTask(taskId, callback) {
  store.dispatch({ type: "ISLOADING", payload: true });
  var sendJSON = {
    action: TaskActions.STOP_ACTION,
    taskId: taskId,
  };
  // alert("SEND JSON:"+JSON.stringify(sendJSON));
  if (callback === undefined) {
    return doTaskAction(sendJSON);
  } else {
    return doTaskActionWithCallback(sendJSON, callback);
  }
}

export function addAccountToAutoDonate(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "addToService",
  };
  startTask("autodonate", taskConfig);
}

export function removeAccountFromAutoDonate(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "removeFromService",
  };
  startTask("autodonate", taskConfig);
}

export function addAccountToAutoClaimPrizes(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "addToService",
  };
  startTask("autoclaimprizes", taskConfig);
}

export function removeAccountFromAutoClaimPrizes(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "removeFromService",
  };
  startTask("autoclaimprizes", taskConfig);
}

export function addAccountToAutoBubble(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "addToService",
  };
  startTask("autobubble", taskConfig);
}

export function removeAccountFromAutoBubble(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "removeFromService",
  };
  startTask("autobubble", taskConfig);
}

export function addAccountToAutoCalendar(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "addToService",
  };
  startTask("autocalendar", taskConfig);
}

export function removeAccountFromAutoCalendar(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "removeFromService",
  };
  startTask("autocalendar", taskConfig);
}

export function removeAccountFromWallRemover(accountdetailrow) {
  var taskConfig = {
    accountdetail: accountdetailrow,
    action: "removeFromService",
  };
  startTask("wallremover", taskConfig);
}
